import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MainMenu from "./MainMenu";
import AdminLeft from "./AdminLeft";
import TopBanner from "./TopBanner";
import Swal from "sweetalert2";

function Newprofile() {

    const getISTDateTime = () => {
        const now = new Date();

        return new Intl.DateTimeFormat("en-CA", {
            timeZone: "Asia/Kolkata",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false
        })
            .format(now)
            .replace(",", "")
            .replace(/\//g, "-");
    };
    const [open, setOpen] = useState(true);

    // Auto collapse on mobile + auto expand on desktop
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setOpen(false); // hide on mobile
            } else {
                setOpen(true); // show on desktop
            }
        };

        handleResize(); // run on load
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const initialForm = {
        id: "",
        billNo: "",
        regNo: "",
        name: "",
        bname: "",
        sex: "",
        caste: "",
        age: "",
        height: "",
        star: "",
        dhosham: "",
        qualification: [""],
        job: "",
        native: "",
        phone: "",
        fee: "",
        mode: "",
        remarks: ""
    };

    const initialForm1 = {
        // id: "",
        // no: "",
        // regNo: "",
        name: "",
        bname: "",
        phone: "",
        star: "",
        // job: "",
        // sex: "",
        // caste: "",
        age: "",
        // height: "",

        // dhosham: "",
        // qualification: [""],
        // native: "",
        // fee: "",
        // mode: "",
        // remarks: "",
        // date: ""
    };

    const [formData, setFormData] = useState(initialForm);
    const [records, setRecords] = useState([]);
    const [editId, setEditId] = useState(null);




    useEffect(() => {
        fetchRecords();
    }, []);

    const fetchRecords = async () => {
        // const res = await fetch("http://localhost/api/get.php");
        const res = await fetch("https://kala.cubixsystems.com/api/get.php");
        const data = await res.json();
        setRecords(data);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleCancel = () => {
        setFormData(initialForm);
        setEditId(null);

        // fetch("http://localhost/api/getRegNo.php")
        fetch("https://kala.cubixsystems.com/api/getRegNo.php")
            .then((res) => res.json())
            .then((data) => {
                setFormData((prev) => ({
                    ...prev,
                    regNo: data.regNo
                }));
            })
            .catch(err => console.error(err));

        fetchRecords();
    }

    // Qualification handlers
    const handleQualificationChange = (index, value) => {
        const updated = [...formData.qualification];
        updated[index] = value;
        setFormData({ ...formData, qualification: updated });
    };

    const addQualification = () => {
        setFormData({
            ...formData,
            qualification: [...formData.qualification, ""],
        });
    };

    const removeQualification = (index) => {
        const updated = formData.qualification.filter((_, i) => i !== index);
        setFormData({ ...formData, qualification: updated });
    };

    const navigate = useNavigate();

    const validateForm = () => {
        // if (!formData.regNo) return "Reg No is mandatory";
        if (!formData.name) return "Name is mandatory";
        if (!formData.bname) return "Bhoomi Name is mandatory";
        if (!formData.phone) return "Phone number is mandatory";
        if (!formData.age) return "Age is mandatory";
        // if (!formData.height) return "Height is mandatory";
        if (!formData.sex) return "Gender is mandatory";
        // if (!formData.caste) return "Caste is mandatory";
        if (!formData.star) return "Star is mandatory";
        // if (!formData.dhosham) return "Dhosham is mandatory";
        // if (!formData.job) return "Job is mandatory";
        // if (!formData.native) return "Native place is mandatory";

        // Qualification check
        // const hasEmptyQualification = formData.qualification.some(q => !q.trim());
        // if (hasEmptyQualification) return "Qualification is mandatory";

        // if (!formData.mode) return "Payment mode is mandatory";
        if (formData.phone.length !== 10) {
            return "Phone Number must be 10 digits";

        }

        return null; // ✅ no errors
    };

    const [file, setFile] = useState(null);

    const [previewFile, setPreviewFile] = useState(null);
    const openPreview = (file) => {
        setPreviewFile(file);
    };

    const [progress, setProgress] = useState(0);
    const [loading, setLoading] = useState(false);

    const handleSave = async () => {
        const error = validateForm();

        if (error) {
            Swal.fire({
                icon: "warning",
                title: "Believer Registration",
                text: error
            });
            return;
        }

        // ✅ STEP 1: Get IST time
        const istDateTime = getISTDateTime();

        // ✅ STEP 2: Merge into formData
        const updatedFormData = {
            ...formData,
            created_at: istDateTime
        };

        const formDataToSend = new FormData();

        Object.keys(updatedFormData).forEach((key) => {
            formDataToSend.append(key, updatedFormData[key]);
        });

        if (file) {
            formDataToSend.append("file", file);
        }

        const url = editId
            ? "https://kala.cubixsystems.com/api/update.php"
            : "https://kala.cubixsystems.com/api/save.php";

        setLoading(true);
        setProgress(0);

        const xhr = new XMLHttpRequest();
        xhr.open("POST", url, true);

        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
                const percent = Math.round((event.loaded / event.total) * 100);
                setProgress(percent);
            }
        };

        xhr.onload = async () => {
            setLoading(false);

            try {
                const data = JSON.parse(xhr.responseText);

                if (data.status === "exists") {
                    Swal.fire({
                        icon: "warning",
                        title: "Duplicate Entry",
                        text: "Phone number already registered!"
                    });
                    return;
                }

                if (data.status === "success" || data.status === "updated") {
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: editId ? "Updated successfully" : "Registered successfully"
                    });

                    setFormData(initialForm);
                    setFile(null);
                    setEditId(null);

                    await fetchRecords();
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: data.msg || "Something went wrong"
                    });
                }

            } catch (err) {
                console.error("Invalid JSON:", xhr.responseText);
            }
        };

        xhr.onerror = () => {
            setLoading(false);
            Swal.fire({
                icon: "error",
                title: "Connection Error",
                text: "Failed to connect to server"
            });
        };

        xhr.send(formDataToSend);
    };

    useEffect(() => {
        fetch("https://kala.cubixsystems.com/api/getRegNo.php")
            .then((res) => res.json())
            .then((data) => {
                console.log("BillNo API:", data); // 🔍 debug

                setFormData((prev) => ({
                    ...prev,
                    billNo: data.billNo
                }));
            })
            .catch((err) => console.error(err));
    }, []);

    const handleEdit = (rec) => {
        setFormData({
            ...rec,
            qualification: rec.qualification
                ? rec.qualification.split(",")
                : [""],
        });
        setEditId(rec.id);
    };

    const handleDelete = async (id) => {

        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This record will be permanently deleted!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        });

        if (result.isConfirmed) {
            try {
                const res = await fetch(`https://kala.cubixsystems.com/api/delete.php?id=${id}`);
                const data = await res.json();

                if (data.status === "deleted") {
                    Swal.fire({
                        icon: "success",
                        title: "Deleted!",
                        text: "Record deleted successfully",
                        timer: 1500,
                        showConfirmButton: false
                    });

                    // Refresh data
                    fetchRecords();

                    //Refresh billNo;
                    fetch("https://kala.cubixsystems.com/api/getRegNo.php")
                        .then((res) => res.json())
                        .then((data) => {
                            setFormData((prev) => ({
                                ...prev,
                                billNo: data.billNo
                            }));
                        });

                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: data.msg || "Delete failed"
                    });
                }

            } catch (err) {
                // Swal.fire({
                //     icon: "error",
                //     title: "Error",
                //     text: "Something went wrong"
                // });
            }
        }
        // ✅ Refresh page
        window.location.reload();
    };

    const [search, setSearch] = useState("");
    const filteredRecords = records.filter((rec) => {
        const searchText = search.toLowerCase();

        return (
            rec.name?.toLowerCase().includes(searchText) ||
            rec.phone?.toLowerCase().includes(searchText)
        );
    });

    const handlePrint = (rec) => {
        // store selected row data
        localStorage.setItem("printData", JSON.stringify(rec));

        // open print page in new tab
        window.open("/print", "_blank");
    };


    const [previewImage, setPreviewImage] = useState(null);

    return (
        <div className="container-fluid p-0">
            <div
                className="top-0 start-0 p-2 fs-3 rounded shadow-sm"
                style={{
                    zIndex: 999,
                    cursor: "pointer",
                    position: "fixed",
                    left: open ? "350px" : "60px",
                    top: "0",
                    transition: "left 0.3s ease"
                }}
                onClick={() => setOpen(!open)}
            >
                <span className="displaysidemenu" style={{ position: "absolute", right: "-10px" }}>
                    ☰
                </span>
            </div>

            <div className="d-flex" style={{ height: "100vh" }}>

                {/* LEFT SIDEBAR */}
                <div
                    className="border-end leftcolor"
                    style={{
                        width: open ? "350px" : "0",
                        overflow: "hidden",
                        transition: "0.3s ease",

                    }}
                >
                    {open && (
                        <div className="p-3">
                            <AdminLeft />
                        </div>
                    )}
                </div>

                {/* RIGHT CONTENT */}
                <div
                    className="p-4"
                    style={{
                        width: open ? "calc(100% - 350px)" : "100%",
                        transition: "0.3s ease",
                        paddiingLeft: '10px'
                    }}
                >
                    <div>
                        <TopBanner />
                    </div>
                    <div className="" style={{ height: '100vh', overflow: 'auto' }}>
                        <div className="row">
                            <div className="col-md-3" style={{ background: 'lightyellow-', padding: '30px', borderRight: '1px groove silver' }}>

                                <h3 className="profile-titles" >New Batch
                                    {/* <span style={{color:'maroon'}}>{formData.name}</span> */}
                                    <br />
                                    {/* <span style={{ fontWeight: '600', fontSize: '15pt', color: 'maroon' }}>{formData.regNo}</span> */}
                                </h3>
                                <table class="table-" style={{ width: '100%' }}>
                                    <tr>
                                        <td colspan="3">
                                            <input name="billNo" type="hidden" placeholder="Bill No" value={formData.billNo} onChange={handleChange} className="form-control" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            {/* <input name="regNo"
                                                type="text"
                                                placeholder="Reg No"
                                                value={formData.regNo}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/\D/g, ""); // only digits
                                                    if (value.length <= 10) { // 🔹 change length if needed
                                                        setFormData({ ...formData, regNo: value });
                                                    }
                                                }}
                                                maxLength={7}
                                                className="form-control" /> */}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input name="bname" type="text" placeholder="Enter Batch" value={formData.name} onChange={handleChange} className="form-control" required />
                                            {/* <input name="name" type="text" placeholder="Name" className="form-control" required /> */}
                                        </td>
                                    </tr>
                                    {/* <tr>
                                        <td colspan="3">
                                            <input name="native" type="text" placeholder="Batch Details" value={formData.native} onChange={handleChange} class="form-control" />
                                        </td>
                                    </tr> */}
                                    {/* <tr>
                                        <td colspan="3">
                                            <input name="bname" type="text" placeholder="ഭൂമിയുടെ പേര് നൽകുക" value={formData.bname} onChange={handleChange} className="form-control" required />
                                            {/* <input name="name" type="text" placeholder="Name" className="form-control" required /> 
                                        </td>
                                    </tr> */}
                                    

                                    

                                    
                                    
                                    
                                    {/* <tr>
                                        <td colspan="3">
                                            <input name="dhosham" type="text" placeholder="Enter Dhosham" value={formData.dhosham} onChange={handleChange} class="form-control" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input name="job" type="text" placeholder="Job" value={formData.job} onChange={handleChange} class="form-control" />
                                        </td>
                                    </tr> */}


                                    <tr>
                                        <td colspan="3">
                                            {/* <div>
                                                {formData.qualification.map((q, i) => (
                                                    <div key={i}>
                                                        <div class="row">
                                                            <div class="col-md-8">
                                                                <input
                                                                    type="text"
                                                                    value={q}
                                                                    onChange={(e) => handleQualificationChange(i, e.target.value)}
                                                                    class="form-control" placeholder="Enter Qualification"
                                                                />
                                                            </div>
                                                            <div class="col-md-4">
                                                                <button class="btn btn-primary" onClick={addQualification} style={{ background: '#004962ff' }}>+</button>
                                                                {formData.qualification.length > 1 && (
                                                                    <button class="btn btn-secondary" onClick={() => removeQualification(i)}>-</button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div> */}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <textarea placeholder="Remarks" name="remarks" value={formData.remarks} onChange={handleChange} class="form-control" style={{ height: '150px' }}></textarea>
                                        </td>
                                    </tr>
                                   
                                     {/* <tr style={{height:'150px'}}>
                                        <td colspan="3">
                                            Upload Photo / PDF (Optional)
                                            <input type="file" class="form-control" accept=".pdf,.jpg,.jpeg,.png"
                                                onChange={(e) => setFile(e.target.files[0])} />
                                        </td>
                                    </tr> */}
                                    <tr>
                                        <td colspan="3">
                                            {/* <div class="col-md-12" style={{ color: 'black', marginTop: '20px', paddingBottom: '20px' }}>
                                                <h5 style={{ paddingBottom: '10px', borderBottom: '1px solid maroon', padding: '15px' }}>Registration Fee:
                                                    <span style={{ marginLeft: '5px', fontWeight: '600', color: 'maroon', marginBottom: '15px' }}>
                                                        Rs. 300
                                                    </span>
                                                </h5>
                                                {["Cash", "UPI", "Debit/Credit Card"].map((m) => (
                                                    <label key={m}>
                                                        <input
                                                            type="radio"
                                                            name="mode"
                                                            value={m}
                                                            checked={formData.mode === m}
                                                            onChange={handleChange}
                                                            style={{ marginLeft: '10px', marginRight: '6px' }} />
                                                        {m}
                                                    </label>
                                                ))}
                                            </div> */}
                                            <div style={{ marginTop: '50px' }}>
                                                {loading && (
                                                    <div style={{ marginTop: "10px" }}>
                                                        <div
                                                            style={{
                                                                width: "100%",
                                                                height: "10px",
                                                                background: "#eee",
                                                                borderRadius: "5px",
                                                                overflow: "hidden"
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    width: `${progress}%`,
                                                                    height: "100%",
                                                                    background: "green",
                                                                    transition: "width 0.3s"
                                                                }}
                                                            ></div>
                                                        </div>

                                                        <p style={{ fontSize: "12px", marginTop: "5px" }}>
                                                            Saving: {progress}%
                                                        </p>
                                                    </div>
                                                )}
                                                {/* <button
                                                    className="col-md-6 btn btn-warning"
                                                    onClick={handleSave}
                                                    disabled={loading}
                                                >
                                                    {loading ? "Processing..." : (editId ? "Update" : "Save")}
                                                </button> */}
                                                <button
                                                    className="col-md-6 btn btn-warning"
                                                    // onClick={handleSave}
                                                    disabled={loading}
                                                >
                                                    {loading ? "Processing..." : (editId ? "Update" : "Save")}
                                                </button>
                                                <button class="col-md-6 btn btn-secondary" onClick={handleCancel}>Cancel</button>
                                            </div>


                                        </td>
                                    </tr>


                                </table>



                            </div>
                            <div class="col-md-9" style={{ height: '80vh', overflow: 'auto', padding: '25px' }}>
                                <h4 className="profile-titles">Batch List</h4>
                                <input
                                    type="text"
                                    placeholder="Search by Batch"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    style={{ marginBottom: "10px", padding: "5px", width: "300px" }}
                                />
                                
                                <div classNmae="table-responsive">
                                    <table className="table" >
                                        <thead>
                                            <tr>
                                                <th style={{ width: '2%' }}>No</th>
                                                <th style={{ width: '15%' }}>Batch </th>
                                                <th style={{ width: '25%' }}>Remarks</th>
                                               
                                                <th style={{ width: '5%' }}></th>
                                            </tr>

                                        </thead>

                                        <tbody>
                                                <td>1</td>
                                                <td>07:00 AM - 08:00 AM</td>
                                                <td>Suitable for Morning Session</td>
                                               
                                                <td> <button className=" btn-primary" style={{ padding: '6px', border: 'none', marginRight: '5px', background: 'white', color: 'maroon', border: '1px solid maroon', cursor: 'pointer' }} ><i class="fa fa-edit"></i></button>
                                                        <button  className=" btn-danger" style={{ padding: '6px', border: 'none', marginRight: '5px', cursor: 'pointer' }}><i class="fa fa-trash"></i></button></td>
                                        </tbody>
                                        </table>
                                </div>

                                {/* <div classNmae="table-responsive">
                                    <table className="table" >
                                        <thead>
                                            <tr>
                                                <th style={{ width: '2%' }}>No</th>
                                                
                                                <th style={{ width: '5%' }}>Name</th>
                                                <th style={{ width: '5%' }}>Phone No</th>
                                                
                                                <th style={{ width: '5%' }}>Course</th>
                                                <th style={{ width: '5%' }}>Date of Registration</th>
                                                <th style={{ width: '5%' }}>Photo</th>
                                                <th style={{ width: '5%' }}></th>
                                            </tr>

                                        </thead>

                                        <tbody>
                                            {filteredRecords.map((rec, index) => (
                                                <tr key={rec.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{rec.name}</td>
                                                    <td>{rec.phone}</td>
                                                   
                                                    <td>{rec.age}</td>
                                                    <td>
                                                        {rec.date
                                                            ? new Intl.DateTimeFormat("en-IN", {
                                                                timeZone: "Asia/Kolkata",
                                                                day: "2-digit",
                                                                month: "2-digit",
                                                                year: "numeric",
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                                hour12: true
                                                            }).format(new Date(rec.date.replace(" ", "T")))
                                                            : ""}
                                                    </td>
                                                    

                                                    <td>
                                                        

                                                        {rec.file?.toLowerCase().endsWith(".pdf") ? (
                                                            <button className="btn btn-warning" style={{ cursor: 'pointer' }} onClick={() => window.open(`https://kala.cubixsystems.com/api/uploads/${rec.file}`, "_blank")}>
                                                                <span><i class="fa fa-eye"></i></span> PDF
                                                            </button>
                                                        ) : (
                                                            
                                                            <img
                                                                src={`https://kala.cubixsystems.com/api/uploads/${rec.file}`}
                                                                style={{ width: "40px", cursor: "pointer" }}
                                                                onClick={() =>
                                                                    setPreviewImage(
                                                                        `https://kala.cubixsystems.com/api/uploads/${rec.file}`
                                                                    )
                                                                }
                                                            />
                                                        )}
                                                    </td>

                                                    <td>

                                                        <button onClick={() => handleEdit(rec)} className=" btn-primary" style={{ padding: '6px', border: 'none', marginRight: '5px', background: 'white', color: 'maroon', border: '1px solid maroon', cursor: 'pointer' }} ><i class="fa fa-edit"></i></button>
                                                        <button onClick={() => handleDelete(rec.id)} className=" btn-danger" style={{ padding: '6px', border: 'none', marginRight: '5px', cursor: 'pointer' }}><i class="fa fa-trash"></i></button>
                                                       
                                                    </td>

                                                </tr>

                                            ))}
                                        </tbody>


                                    </table>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="container">




            </div>
            {previewImage && (
                <div
                    onClick={() => setPreviewImage(null)}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.8)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999
                    }}
                >
                    <img
                        src={previewImage}
                        style={{
                            maxWidth: "90%",
                            maxHeight: "90%",
                            borderRadius: "8px"
                        }}
                    />
                </div>
            )}
        </div>

    );
}


export default Newprofile;

